import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
var CLASS_NAME = 'asc-btn';
var propTypes = {
  /**
   * Class appended to asc-btn, same options as a button
   **/
  className: PropTypes.string,
  /**
   * Text to display on button
   **/
  text: PropTypes.string.isRequired,
  /**
   * URL to redirect to
   **/
  link: PropTypes.string.isRequired,
  /**
   * If needed, a function can be passed for tracking
   **/
  analyticsHandler: PropTypes.func
};
var defaultProps = {
  className: '',
  analyticsHandler: function analyticsHandler() {}
};
var ButtonLink = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ButtonLink, _Component);
  function ButtonLink(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.clickHandler = function () {
      var analyticsHandler = _this.props.analyticsHandler;
      analyticsHandler();
    };
    return _this;
  }
  var _proto = ButtonLink.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      className = _this$props.className,
      link = _this$props.link,
      text = _this$props.text;
    var classNames = !className ? CLASS_NAME : CLASS_NAME + ' ' + className;
    return /*#__PURE__*/React.createElement("a", {
      onClick: this.clickHandler,
      href: link,
      className: classNames
    }, text);
  };
  return ButtonLink;
}(Component);
ButtonLink.propTypes = propTypes;
ButtonLink.defaultProps = defaultProps;
export default ButtonLink;